import { issuerDomainMapService } from "../services/issuerDomainMap.service";
import { show as showAlert } from "../../Notifications/actions/alert.actions";
import { message } from "../../../constants/app.constants";
import { issuerDomainMapConstants, nameSpace } from "../constants/issuerDomainMap.constants";
import { createRequestBody } from "../factories/issuerDomainMap.factory";
import { reset } from "redux-form";

export const resetPost = () => {
    return { type: issuerDomainMapConstants[`POST_${nameSpace}_RESET`] };
};

export const resetView = () => {
    return { type: issuerDomainMapConstants[`VIEW_${nameSpace}_RESET`] };
};

export const getAllIssuerDomainMappings = (requestParams) => {

    return async (dispatch) => {
        dispatch(request(requestParams));
        try {
            const response = await issuerDomainMapService.getAllissuerDomainMappings(requestParams);
            response && dispatch(success(response));
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "Failed to get issuer domain mappings", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request(request) {
        return {
            type: issuerDomainMapConstants[`GET_${nameSpace}_REQUEST`],
            request,
        };
    }
    function success(response) {
        return {
            type: issuerDomainMapConstants[`GET_${nameSpace}_SUCCESS`],
            response,
        };
    }
    function failure(error) {
        return {
            type: issuerDomainMapConstants[`GET_${nameSpace}_FAILURE`],
            error,
        };
    }
};

export const viewIissuerDomainMapping = (domainCode) => {
    return async (dispatch) => {
        dispatch(request(domainCode));
        try {
            const response = await issuerDomainMapService.viewIissuerDomainMapping(domainCode);
            response && dispatch(success(response));
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", "Failed to get selected mappiing", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request(request) {
        return {
            type: issuerDomainMapConstants[`VIEW_${nameSpace}_REQUEST`],
            request,
        };
    }
    function success(response) {
        return {
            type: issuerDomainMapConstants[`VIEW_${nameSpace}_SUCCESS`],
            response,
        };
    }
    function failure(error) {
        return {
            type: issuerDomainMapConstants[`VIEW_${nameSpace}_FAILURE`],
            error,
        };
    }
};

export const createIssuerDomainMapping = (values, domainCode, history) => {
    // if(domainCode){
    //   values['domains']=domainCode;
    // }
    const requestBody = createRequestBody(values, domainCode);
    return async (dispatch) => {
        dispatch(request(requestBody));
        try {
            const response = await issuerDomainMapService.createIssuerDomainMapping(requestBody, domainCode);
            
            dispatch(success(response));
            dispatch(reset("issuerDomainMapping_form"));
            if (domainCode) {
                dispatch(showAlert("success", null, "Issuer/domain mapping saved successfully", response && response.responseMessage));
                history.push("/issuer-mapping");
            } else {
                dispatch(showAlert("success", "Issuer/domain mapping saved successfully", response && response.responseMessage));
            }

            dispatch(getAllIssuerDomainMappings({ page: 1, pageSize: 10 }));
            dispatch(resetPost());
            if (domainCode) {
                dispatch(viewIissuerDomainMapping(domainCode));
            } else {
                dispatch(resetView());
            }
        } catch (error) {
            dispatch(failure(error));
            dispatch(showAlert("danger", domainCode ? "Failed to update issuer/domain mapping" : "Failed to save issuer/domain mapping", error ? error.message : message.GENERIC_ERROR));
        }
    };

    function request() {
        return { type: issuerDomainMapConstants[`POST_${nameSpace}_REQUEST`] };
    }
    function success(response) {
        return {
            type: issuerDomainMapConstants[`POST_${nameSpace}_SUCCESS`],
            response,
        };
    }
    function failure(error) {
        return {
            type: issuerDomainMapConstants[`POST_${nameSpace}_FAILURE`],
            error,
        };
    }
    function resetPost() {
        return { type: issuerDomainMapConstants[`POST_${nameSpace}_RESET`] };
    }
};
